var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stories-item",on:{"click":function($event){return _vm.show()}}},[_c('div',{staticClass:"item-image"},[(_vm.imagePath !== '')?_c('img'):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }